import { Link } from 'react-router-dom'
import './Footer.css'

function IconInstagram() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
    </svg>
  )
}

function IconFacebook() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
    </svg>
  )
}

function IconTiktok() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.78a4.85 4.85 0 0 1-1.01-.09z"/>
    </svg>
  )
}

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/portfolio', label: 'Portfolio' },
  { to: '/tattoo-therapy', label: 'Tattoo Therapy' },
  { to: '/book', label: 'Book Now' },
  { to: '/contact', label: 'Contact' },
]

const socialLinks = [
  { href: 'https://instagram.com/jessebtatoos', label: 'Instagram', Icon: IconInstagram },
  { href: 'https://facebook.com/jessebtatoos', label: 'Facebook', Icon: IconFacebook },
  { href: 'https://tiktok.com/@jessebtatoos', label: 'TikTok', Icon: IconTiktok },
]

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner container">
        <div className="footer__brand">
          <Link to="/" className="footer__logo" aria-label="Jesse B Tattoos — Home">
  <img
    src="/logo.png"
    alt="Jesse B Tattoos"
    className="footer__logo-img"
  />
</Link>
          <p className="footer__tagline">
            Bold ink. Real art.<br />Your story on your skin.
          </p>
          <div className="footer__social" aria-label="Social media links">
            {socialLinks.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={`Jesse B Tattoos on ${label}`}
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        <nav className="footer__nav" aria-label="Footer navigation">
          <h3 className="footer__heading">Navigate</h3>
          <ul role="list">
            {navLinks.map(({ to, label }) => (
              <li key={to}>
                <Link to={to} className="footer__link">{label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="footer__contact">
          <h3 className="footer__heading">Get In Touch</h3>
          <address>
            <p className="footer__location">
              1/5 Canberra Dr<br />
              Aberfoyle Park, Adelaide, SA 5159
            </p>
            <p>
              <a href="mailto:admin@jessebtattoo.com" className="footer__link">
                admin@jessebtattoo.com
              </a>
            </p>
          </address>
          <Link to="/book" className="footer__cta">
            Book a Session
          </Link>
        </div>
      </div>

     <div className="footer__bottom">
  <div className="container">
    <p>
      &copy; {year} Jesse B Tattoos. All rights reserved.{' '}
      <a
        href="https://2merative.com"
        target="_blank"
        rel="noopener noreferrer"
        className="footer__link"
      >
        Built by 2merative.com
      </a>
    </p>
    <p className="footer__credit">
      Tattoos are art. Art is forever.
    </p>
  </div>
</div>
    </footer>
  )
}